import {Actor, ExpertDetails, PagedResult, UserProfile} from "./actorenApi.ts";
import {getCsrfToken} from "./genericApi.ts";
import {Konto} from "@/services/kontoApi.ts";
import {Addendum} from "@/services/wizardApi.ts";

export interface ExpertAdmin extends ExpertDetails {
    van: Date,
    tot: Date,
}


export interface SystemHealthInfo {
    applicationVersion : string,
    commitId : string,
    jvmProperties : string[],
    heapMemoryUsage : string,
    nonHeapMemoryUsage : string,
    instanceType : string,
    profile : string
}

export interface DubbelRegistratie {
    email: string,
    actorIds: number[],
    aantal: number
}


export interface KontoAdmin extends Konto {
    naam: string,
    email: string,
    telefoon: string
}



export function cleanFilter(filter: Record<string, any>): Record<string, string> {
    return Object.fromEntries(
        Object.entries(filter).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
}


export interface KontoFilter {
    status?: string;
    zoekterm?: string;
    aangemaaktVanaf?: string;
    aangemaaktTot?: string;
}



export async function getBezoekers(): Promise<UserProfile[]> {

    const response = await fetch('/api/admin/actoren/bezoekers', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
}

export async function getExperts(): Promise<ExpertAdmin[]> {

    const response = await fetch('/api/admin/actoren/experts', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
}

export async function getOrganisatons(): Promise<Actor[]> {

    const response = await fetch('/api/admin/actoren/organisaties', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
}

export async function getAddenda(): Promise<Addendum[]> {

    const response = await fetch('/api/admin/addenda/', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
}

export async function getDubbeleRegistraties(): Promise<DubbelRegistratie[]> {

    const response = await fetch('/api/admin/actoren/dubbels', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
    
    }



export async function updateAddendum(addendum: Addendum): Promise<Addendum> {

    const token = getCsrfToken();

    const response = await fetch('/api/admin/addenda', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: JSON.stringify(addendum),
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Update failed with status ${response.status}`)
    }
    return response.json();
}

export async function createAddendum(addendum: Addendum): Promise<Addendum> {
    const token = getCsrfToken();

    const response = await fetch('/api/admin/addenda', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: JSON.stringify(addendum),
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Creation failed with status ${response.status}`)
    }
    return response.json();
}

export async function deleteAddendum(id: any): Promise<void> {

    const token = getCsrfToken();

    const response = await fetch(`/api/admin/addenda/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Deletion failed with status ${response.status}`)
    }
}

export async function getSystemHealthInfo(): Promise<SystemHealthInfo> {
    const response = await fetch('/api/admin/system-health', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
}

export async function deleteKonto(id : number): Promise<void> {
    const csrfToken = getCsrfToken();

    const response = await fetch(`/api/admin/kontos/${id}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
            'X-XSRF-TOKEN': csrfToken
        }
    });
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
}

export async function deleteOrganisation(id: number) {
    const csrfToken = getCsrfToken();

    const response = await fetch('/api/admin/actoren/organisaties/' + id, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
            'X-XSRF-TOKEN': csrfToken
        }
    });
    if (!response.ok) throw new Error(`deleteOrganisation failed: ${response.status}`);
}


export async function deletePersoon(id: number): Promise<void> {
    const csrfToken = getCsrfToken();

    const response = await fetch(`/api/admin/actoren/${id}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
            'X-XSRF-TOKEN': csrfToken
        }
    });
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
}

async function zoekMogelijkeDubbels(): Promise<DubbelRegistratie[]> {
    const response = await fetch('/api/admin/personen/dubbels', {
        method: 'GET',
        credentials: 'include'
    });
    if (!response.ok) throw new Error(`zoekMogelijkeDubbels failed: ${response.status}`);
    return response.json();
}